import './App.css';
import './Checkout';
import Checkout from './Checkout';
import PaymentForm from './components/PaymentForm';
import { PaymentProvider } from './components/PaymentContext';

function App() {
  return (
    <PaymentProvider>
      <Checkout/>
    </PaymentProvider>
  );
}

export default App;
